import React, { useState } from 'react';

import { HStack, VStack, Button } from '@chakra-ui/react';

import SupplierSettings from './SupplierSettings';
import RawSupplierInventory from './RawSupplierInventory';
import SupplierDropdown from './SupplierDropdown';
import SupplierInfoCard from './SupplierInfoCard';
import MarketplaceListingInfo from './MarketplaceListingInfo';

const AdvancedTab = ({
  listing,
  onListingUpdate,
  onUpdate,
  isUpdating = false,
  hasChanges = false,
}) => {
  // Combine current supplier with other evaluated suppliers
  const allSuppliers = React.useMemo(() => {
    const suppliers = [];

    // Add the current supplier first (if it exists)
    if (listing?.supplier) {
      suppliers.push({
        ...listing.supplier,
        isSelected: true,
      });
    }

    // Add other evaluated suppliers
    if (
      listing?.otherEvaluatedSuppliers &&
      Array.isArray(listing.otherEvaluatedSuppliers)
    ) {
      suppliers.push(
        ...listing.otherEvaluatedSuppliers.map((supplier) => ({
          ...supplier,
          isSelected: false,
        })),
      );
    }

    return suppliers;
  }, [listing?.supplier, listing?.otherEvaluatedSuppliers]);

  const [selectedSupplier, setSelectedSupplier] = useState(allSuppliers[0] || null);

  // Update selected supplier when listing changes
  React.useEffect(() => {
    if (allSuppliers.length > 0 && !selectedSupplier) {
      setSelectedSupplier(allSuppliers[0]);
    }
  }, [allSuppliers, selectedSupplier]);

  const handleSupplierChange = (supplier) => {
    setSelectedSupplier(supplier);
  };

  const isSynced = listing?.status === 'synced';

  return (
    <VStack spacing={6} align="stretch">
      {/* Supplier sections - only show if listing has been synced */}
      {isSynced && (
        <>
          {/* First Row: Supplier Settings and Raw Supplier Inventory */}
          <HStack spacing={4} align="stretch">
            <SupplierSettings listing={listing} />
            <RawSupplierInventory listing={listing} />
          </HStack>

          {/* Second Row: Supplier Dropdown and Supplier Info Card */}
          <HStack spacing={4} align="stretch">
            <SupplierDropdown
              suppliers={allSuppliers}
              selectedSupplier={selectedSupplier}
              onSupplierChange={handleSupplierChange}
            />
            <SupplierInfoCard selectedSupplier={selectedSupplier} />
          </HStack>
        </>
      )}

      {/* Third Row: Marketplace Listing Info - always show */}
      <MarketplaceListingInfo
        listing={listing}
        onUpdate={onListingUpdate}
        onUpdateAction={onUpdate}
      />

      <HStack justify="flex-end" spacing={4} pt={4}>
        <Button
          colorScheme="blue"
          size="md"
          w="20%"
          onClick={onUpdate}
          isLoading={isUpdating}
          loadingText="Updating..."
          isDisabled={!hasChanges || isUpdating}
        >
          Update
        </Button>
      </HStack>
    </VStack>
  );
};

export default AdvancedTab;
